<template>
  <div>
    <header class="dashboard-header">
      <div class="dashboard-wrapper container">
        <div class="profile-wrapper">
          <div class="dashboard-logo">
            <img src="../assets/Images/dashboard-logo.svg" alt="PropertyPistol" />
          </div>
          <a class="text-reset text-decoration-none" data-bs-toggle="modal" data-bs-target="#profile-menu">
            <div id="profile" class="user-profile">
              <div class="user-info">
                <div class="user-name">{{userName}}</div>
                <div class="user-department">{{userRole}}</div>
              </div>
                <div class="user-avatar">
                  <img :src="userProfile ? userProfile : '../assets/Images/profile.png'" style="width:100%" alt="">
                </div>
            </div>
          </a>
        </div>
        <div class="dashboard-info">
          <div class="date">
            <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg" >
              <path d="M9.5625 1.42188H8.54688V1.21875C8.54688 1.05713 8.48267 0.902137 8.36839 0.787857C8.25411 0.673577 8.09912 0.609375 7.9375 0.609375C7.77588 0.609375 7.62089 0.673577 7.50661 0.787857C7.39233 0.902137 7.32812 1.05713 7.32812 1.21875V1.42188H3.67188V1.21875C3.67188 1.05713 3.60767 0.902137 3.49339 0.787857C3.37911 0.673577 3.22412 0.609375 3.0625 0.609375C2.90088 0.609375 2.74589 0.673577 2.63161 0.787857C2.51733 0.902137 2.45312 1.05713 2.45312 1.21875V1.42188H1.4375C1.16814 1.42188 0.909811 1.52888 0.719345 1.71934C0.528878 1.90981 0.421875 2.16814 0.421875 2.4375V10.5625C0.421875 10.8319 0.528878 11.0902 0.719345 11.2807C0.909811 11.4711 1.16814 11.5781 1.4375 11.5781H9.5625C9.83186 11.5781 10.0902 11.4711 10.2807 11.2807C10.4711 11.0902 10.5781 10.8319 10.5781 10.5625V2.4375C10.5781 2.16814 10.4711 1.90981 10.2807 1.71934C10.0902 1.52888 9.83186 1.42188 9.5625 1.42188ZM2.45312 2.64062C2.45312 2.80224 2.51733 2.95724 2.63161 3.07152C2.74589 3.1858 2.90088 3.25 3.0625 3.25C3.22412 3.25 3.37911 3.1858 3.49339 3.07152C3.60767 2.95724 3.67188 2.80224 3.67188 2.64062H7.32812C7.32812 2.80224 7.39233 2.95724 7.50661 3.07152C7.62089 3.1858 7.77588 3.25 7.9375 3.25C8.09912 3.25 8.25411 3.1858 8.36839 3.07152C8.48267 2.95724 8.54688 2.80224 8.54688 2.64062H9.35938V3.85938H1.64062V2.64062H2.45312ZM1.64062 10.3594V5.07812H9.35938V10.3594H1.64062Z" fill="white" />
            </svg>
            <span>{{$moment().format('ddd, DD MMMM YYYY')}}</span>
          </div>
          <div class="dashboard-title">Manage All Your Loanz Leads</div>
        </div>
      </div>
    </header>
    <section class="container py-3">
      <h3 class="section-title">Lead Sections</h3>
      <div class="lead-sections">
        <ul class="row row-cols-4 g-2 justify-content-around">
          <li v-for="(ls,key) in leadSection"   @click="$router.push({name: 'Leads', query: {status_id: ls.value}})" :key="key"><img class="rounded-3" :src="ls.img"  alt="">{{ls.name}}</li>
        </ul>
      </div>
    </section>
    <section class="container pt-3 latest-leads">
      <h3 class="section-title">Latest Leads</h3>
      <div class="card border-0 lead-card mb-3" v-for="(loan,key) in loanLeadList" :key="key">
        <router-link class="text-decoration-none" :to="{ name: 'loanDetails',  params: {  id: loan.id }}">
        <div class="card-header bg-transparent border-0 py-1">
          <span class="badge rounded-pill bg-light text-secondary fs-6 me-2" v-if="loan.logged_in">Logged</span>
          <span class="badge rounded-pill bg-light text-secondary fs-6 me-2" v-if="loan.sactioned">Sanctioned</span>
          <span class="badge rounded-pill bg-light text-secondary fs-6 me-2" v-if="loan.disbursed">Disbursed</span>
          <span class="badge rounded-pill bg-light text-secondary fs-6 me-2" v-if="loan.insured">Insured</span>
        </div>
        <div class="card-body pt-1">
          <h5 class="card-title fs-3 text-dark">{{loan.lead_name}}</h5>
          <p class="card-text fs-5 text-light">{{loan.loan_number}} <span class="lead-status text-primary ms-1">{{loan.status}}</span></p>
        </div>
      </router-link>
        <router-link :to="{ name: 'Edit',  params: {  id: loan.id }}" class="lead-edit btn btn-info rounded-circle btn-sm ms-auto text-reset">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.431 3.01241L8.98758 0.568425C8.90633 0.487153 8.80986 0.422683 8.70369 0.378697C8.59752 0.334712 8.48372 0.312073 8.36879 0.312073C8.25387 0.312073 8.14007 0.334712 8.0339 0.378697C7.92773 0.422683 7.83126 0.487153 7.75 0.568425L1.00649 7.31249C0.924884 7.39345 0.860185 7.48982 0.816154 7.596C0.772123 7.70218 0.749637 7.81605 0.750004 7.931V10.375C0.750004 10.6071 0.842192 10.8296 1.00629 10.9937C1.17038 11.1578 1.39294 11.25 1.625 11.25H4.06899C4.18394 11.2504 4.29781 11.2279 4.404 11.1838C4.51018 11.1398 4.60655 11.0751 4.6875 10.9935L11.431 4.24999C11.5123 4.16873 11.5768 4.07227 11.6207 3.96609C11.6647 3.85992 11.6874 3.74612 11.6874 3.6312C11.6874 3.51628 11.6647 3.40248 11.6207 3.2963C11.5768 3.19013 11.5123 3.09366 11.431 3.01241ZM9.5 4.94343L7.05602 2.49999L8.36852 1.18749L10.8125 3.63093L9.5 4.94343Z" fill="white"/>
          </svg>
        </router-link>
        <span class="btn-bg" aria-label="hidden"></span>
      </div>
    </section>
    <div class="container">
        <router-link class="add-lead btn btn-secondary fs-3 py-2" to="/new">+ Add New Loan Lead</router-link>
    </div>
   <Footer activeStatus="Dashboard"/>
   <Menu/>
  </div>
</template>

<script>
import Menu from '../components/Menu.vue';
import Footer from '../components/layouts/Footer.vue'
import qs from 'qs';
export default {
  components: {
    Menu,
    Footer
  },
  data() {
    return {
      loanLeadList: [],
      perPage: 0,
      total: 0,
      leadSection: [
        {
          value: 'logged_in',
          name: 'Logged',
          img: require('../assets/Images/logged.svg')
        },
        {
          value: 'sactioned',
          name: 'Sanctioned',
          img: require('../assets/Images/sanctioned.svg')
        },
        {
          value: 'disbursed',
          name: 'Disbursed',
          img: require('../assets/Images/disbursed.svg')
        },
        {
          value: 'insured',
          name: 'insured',
          img: require('../assets/Images/insured.svg')
        },
      ]
    }
  },
  methods: {
    fetchLeads() {
      let queryP = {}
      this.$axios.get('/loanz?latest_leads=true', {
        params: queryP,
      })
        .then(res => {
          this.loanLeadList = res.data.loanz;
          this.perPage = res.data.per_page;
          this.total = res.data.total_count;
        })
        .catch(err => console.log(err));
    }
  },
  mounted() {
    this.fetchLeads()
    this.$store.dispatch('setnewLoanData', null);
  },
  computed: {
    userName(){
      return localStorage.getItem('loan-crm-user-name')
    },
    userRole(){
      return localStorage.getItem('loan-crm-user-role')
    },
    userProfile(){
      return localStorage.getItem('loan-crm-user-profile')
    }
  }
}
</script>

<style>

</style>